var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 1.99998C11.5086 1.82488 11.7165 1.68599 11.9452 1.59123C12.174 1.49647 12.4192 1.44769 12.6668 1.44769C12.9145 1.44769 13.1597 1.49647 13.3884 1.59123C13.6172 1.68599 13.8251 1.82488 14.0002 1.99998C14.1753 2.17507 14.3142 2.38294 14.4089 2.61172C14.5037 2.84049 14.5524 3.08569 14.5524 3.33331C14.5524 3.58093 14.5037 3.82613 14.4089 4.05491C14.3142 4.28368 14.1753 4.49155 14.0002 4.66664L5.00016 13.6666L1.3335 14.6666L2.3335 11L11.3335 1.99998Z",
    stroke: "#9E77ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/PencilIcon.ea3eacda80066b8eb2643c5c816c33fa.svg";
export { ForwardRef as ReactComponent };